import React from "react";
import { useNavigate } from "react-router-dom";
import { Gift } from "lucide-react";
import { Dialog, DialogContent } from "./ui/dialog";
import { Button } from "./ui/button";
import { useApp } from "../context/AppContext";

export default function WelcomeBonusModal() {
  const { showBonusPopup, closeBonusPopup } = useApp();
  const navigate = useNavigate();

  const goDeposit = () => {
    closeBonusPopup();
    navigate("/wallet?tab=deposit");
  };

  return (
    <Dialog open={showBonusPopup} onOpenChange={(v) => { if (!v) closeBonusPopup(); }}>
      <DialogContent className="sm:max-w-sm text-center" data-testid="welcome-bonus-modal">
        <div className="flex flex-col items-center gap-4 pt-2">
          <div className="h-16 w-16 rounded-2xl bg-primary/15 grid place-items-center ring-1 ring-primary/25">
            <Gift className="h-8 w-8 text-primary" />
          </div>
          <div className="space-y-1.5">
            <h2 className="font-display font-bold text-2xl">Welcome to BatBallWorld! 🏏</h2>
            <p className="text-sm text-muted-foreground" data-testid="welcome-bonus-message">
              Unlock your welcome bonus on your first deposit.
            </p>
          </div>
          <div className="w-full space-y-2 pt-1">
            <Button className="w-full font-semibold" onClick={goDeposit} data-testid="welcome-bonus-deposit-btn">
              Make your first deposit
            </Button>
            <button
              type="button"
              onClick={closeBonusPopup}
              className="w-full text-sm text-muted-foreground hover:text-foreground transition-colors py-1"
              data-testid="welcome-bonus-dismiss-btn"
            >
              Maybe later
            </button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
